<ckeditor 
	[editor]="editor" 
	[config]="{ toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'] }" 
	[(ngModel)]="wysiwygValue" 
	name="wysiwyg"
	(ngModelChange)="onCkEditorChange()">
</ckeditor>
